module.exports = __webpack_public_path__ + "img/upload-doc.7442e3e3.svg";